module.exports = __webpack_public_path__ + "media/images/mobile/solutions/30-493b5aad835bef64c34e9fc015d8874e.png";